import { getCookie, setCookie } from './cookies/cookies';

const ANON_ID_COOKIE_NAME = 'ld_anonymous_id';
export const ANON_ID_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

function generateAnonymousId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  const timestamp = Date.now().toString(16);
  const random = Math.random()
    .toString(16)
    .slice(2);
  return `${timestamp}-${random}`;
}

export function getOrCreateAnonymousUserKey(): string {
  const existing = getCookie(ANON_ID_COOKIE_NAME);

  if (existing && existing.trim().length > 0) {
    return existing;
  }

  const anonId = generateAnonymousId();
  setCookie(ANON_ID_COOKIE_NAME, anonId, ANON_ID_MAX_AGE_SECONDS);

  return anonId;
}
